/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TemplateRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model(params) {
    return hash({
      schema: this.store.findRecord('enrolments/schema', params.schema_id),

      fieldSets: this.store.findAll('people-schema/set'),
      fieldGroups: this.store.findAll('people-schema/group'),
      allFields: this.store.findAll('people-schema/field'),
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      if (
        isEmpty(transition.from) ||
        !transition.from.find((route) => route.name === this.routeName)
      ) {
        return;
      }
      if (!transition.to.find((route) => route.name === this.routeName)) {
        if (this.get('controller.recordIsDirty')) {
          if (
            window.confirm(
              'You have unsaved changes which will be lost if you leave this page.  Are you sure you wish to leave?',
            )
          ) {
            this.get('controller.schema').rollbackAttributes();
          } else {
            transition.abort();
          }
        }
      }
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
